import { useState } from "react";

import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Typewriter from "../Typewriter";

export const WizardVariable = ({ i, label, defaultValue, displayAs, displayParams }) => {
    const [ isUpdated, setIsUpdated ] = useState(false);
    
    const id = `variableInput${i}`;
    label = label || '';
    defaultValue = defaultValue || '';
    displayAs = displayAs || 'inputGroup';
    displayParams = displayParams || {};

    switch (displayAs) {
        case 'textarea':
            const rows = displayParams.rows || 14;
            const spellCheck = displayParams.spellCheck || 'false';

            return (<>
                <span
                    className="input-group-text a8-blue-background"
                    style={{ borderBottomRightRadius: 0, borderBottomLeftRadius: 0 }}
                >
                    {label}
                </span>

                <Form.Control
                    id={id}
                    as="textarea"
                    defaultValue={defaultValue}
                    style={{ borderTopRightRadius: 0, borderTopLeftRadius: 0 }}
                    onChange={() => setIsUpdated(true)}
                    rows={rows}
                    autoFocus
                    spellCheck={spellCheck}
                />

                <div className="mt-2">
                    {!isUpdated && defaultValue.length > 0 ? (
                        <>
                            <i className="bi-arrow-up-circle-fill a8-orange mx-2" />
                            <Typewriter
                                text="^This is a sample. ^Replace with your content."
                                className="a8-orange"
                                delay={20}
                            />
                        </>
                    ) : 
                        <>&nbsp;</>
                    }
                </div>
            </>);
        default:
            return (
                <InputGroup className="mb-3">
                    <InputGroup.Text className="a8-blue-background">
                        {label}
                    </InputGroup.Text>
                    <Form.Control
                        id={id}
                        defaultValue={defaultValue} />
                </InputGroup>
            );
    }



};
